// extracted by mini-css-extract-plugin
export default {"positionIcon":"AuditsEmpty_positionIcon__WlyCj","content":"AuditsEmpty_content__BPtRd"};